import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const PhotosIcon = ({ color = '#8CA4C9', size = 35, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 29"
    width={size}
    {...props}
  >
    <g fill={color} fillRule="evenodd">
      <path d="M32.01 6.453h-3.88l-.399-3.879c-.072-.688-.399-1.34-.943-1.775a2.645 2.645 0 0 0-1.921-.58l-22.33 2.39c-1.45.145-2.5 1.45-2.319 2.864l1.776 16.928a2.63 2.63 0 0 0 2.61 2.357h.29l2.103-.218v1.594c0 1.45 1.16 2.61 2.61 2.61h22.402c1.45 0 2.61-1.16 2.61-2.61V9.097c0-1.448-1.16-2.644-2.61-2.644zM6.96 9.099v13.304l-2.32.253c-.253.037-.544-.181-.544-.434L2.32 5.256c0-.181.073-.29.11-.362.036-.073.144-.145.325-.182l22.294-2.356h.037c.144 0 .253.072.325.11.073.036.145.144.182.325l.399 3.662H9.569c-1.45 0-2.61 1.196-2.61 2.646zm25.52 17.038c0 .29-.218.507-.507.507H9.57a.495.495 0 0 1-.507-.507v-7.324l4.278-4.278a1.202 1.202 0 0 1 1.704 0l8.59 8.591c.218.218.472.326.762.326.29 0 .544-.109.762-.326.4-.399.4-1.087 0-1.486l-.943-.944 2.212-2.211c.072-.073.218-.073.29 0l5.763 5.8v1.852zm0-4.858L28.203 17a2.342 2.342 0 0 0-3.3 0l-2.175 2.212-6.162-6.163a3.317 3.317 0 0 0-2.357-.978c-.906 0-1.74.362-2.356.978l-2.79 2.756V9.099c0-.29.217-.506.506-.506h22.403c.29 0 .507.218.507.506l.001 12.18z" />
      <path d="M29.688 12.543a2.029 2.029 0 1 1-4.058 0 2.029 2.029 0 0 1 4.058 0" />
    </g>
  </svg>
);

PhotosIcon.propTypes = propTypes;

export default PhotosIcon;
